import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';


export default {
  name: 'matrix',
  components: {
    Paginate,
    VueElementLoading
  },
  props: {
    headerArray: {
      type: Array,
      required: true
    },
    verticalHeaderArray: {
      type: Array,
      required: false
    },
    tableDataArray: {
      type: Array,
      required: true
    },
    label: {
      type: Object,
      required: false
    },
    isSaveButtonHidden: {
      type: Boolean,
      required: false
    },
    isDisabled:{
      type: Boolean,
      required: false
    }
  },
  data: function () {
    return {
      finalRatesForRetail: [],
      showTable: true,
      isLoading:false,
      showErrorMsg:false,
      clientListObjData: {
        value: null,
        text: null
      },
    }
  },
  computed: {
    hsSteps() {
      return [{
        slot: "page1",
        onNext: () => {
          this.$refs.selectClientName.validate();
        },
        isValid: () => {
          this.updateZoneRate();
        }
      },];
    }
  },
  mounted() {
  },
  methods: {
    isNumber: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
			  evt.preventDefault();;
			} else {
			  return true;
			}
		},
    async updateZoneRate(event) {
      this.$validator.validateAll(event).then((result) => {
        if(!result){
          this.$alert("Empty fields are not allowed","","info");
          return false;
        }
         this.$emit("updatedMatrixData",this.tableDataArray)
    }).catch(() => {
      console.log('errors exist', this.errors)
      this.$alert("Error","","error");
    });
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/components/matrix/matrix.component.js